import { LIGHT_GRAY, NEAR_WHITE } from "@shape/reef-shared";
import styled from "styled-components";

export const Container = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: ${NEAR_WHITE};
  margin: auto;

  svg {
    color: ${LIGHT_GRAY};
    margin-bottom: 32px;
  }

  h2 {
    font-weight: normal;
  }

  div {
    color: ${LIGHT_GRAY};
    font-size: 14px;
    margin-bottom: 32px;
    width: 340px;
  }
`;
